import {
  inputFields,
  tables,
  Buttons,
  popover,
  upload,
} from "../../components";

const Restaurants = ({ state, setState, setActiveTab }) => {
  const handleRestaurantChange = (index, field, value) => {
    const updatedRestaurants = [...state.restaurants];
    updatedRestaurants[index][field] = value;
    setState({ ...state, restaurants: updatedRestaurants });
  };

  const addRestaurant = () => {
    const newRestaurant = {
      restaurantName: "",
      distance: "",
      imageURL: "",
    };
    setState({
      ...state,
      restaurants: [...state.restaurants, newRestaurant],
    });
  };

  const removeRestaurant = (index) => {
    const updatedRestaurants = state.restaurants.filter((_, i) => i !== index);
    setState({ ...state, restaurants: updatedRestaurants });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "restaurantName",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleRestaurantChange(index, "restaurantName", e.target.value)
          }
        />
      ),
    },
    {
      title: "Distance (km)",
      dataIndex: "distance",
      width: 350,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          type="number"
          onChange={(e) =>
            handleRestaurantChange(index, "distance", e.target.value)
          }
        />
      ),
    },
    {
      title: "Image",
      dataIndex: "imageURL",
      width: 350,
      render: (text, record, index) => (
        <popover.WhitePopover
          content={<img src={text} className="h-[5em] w-full" />}
          trigger="hover"
          placement="top"
        >
          <div>
            <upload.DefaultFileUpload
              onChange={(e) => handleRestaurantChange(index, "imageURL", e)}
              value={text}
              type="image"
              showcrop
            />
          </div>
        </popover.WhitePopover>
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeRestaurant(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.restaurants}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addRestaurant}>
          Add Restaurant
        </Buttons.DefaultButton>

        <Buttons.DefaultButton size="medium" onClick={() => setActiveTab("6")}>
          Next
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default Restaurants;
